import { render, staticRenderFns } from "./DriverManagement.vue?vue&type=template&id=69879680&"
import script from "./DriverManagement.vue?vue&type=script&lang=js&"
export * from "./DriverManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports